export default "__VITE_ASSET__CvzvT735__"